module.exports = __webpack_public_path__ + "img/safe_tool_5.16d00773.jpg";